export default __webpack_public_path__ + "static/media/high_availability_number.5d20952a.svg";